import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateClass as apiUpdate } from "../../api/apiClasses";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateClass() {
    const navigate = useNavigate(); const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: editClass, isPending: isUpdate, error } = useMutation({
        mutationFn: ({ req, id }) => apiUpdate(req, id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["classes"] }); navigate('/classes'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { editClass, isUpdate, error };
}
